export default __webpack_public_path__ + "static/3-da41cfd829a6ab88ac2bb90a2a21f925.jpg";